import { render, staticRenderFns } from "./Proficiencies.vue?vue&type=template&id=585b54d1&scoped=true&"
import script from "./Proficiencies.vue?vue&type=script&lang=js&"
export * from "./Proficiencies.vue?vue&type=script&lang=js&"
import style0 from "./Proficiencies.vue?vue&type=style&index=0&id=585b54d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b54d1",
  null
  
)

export default component.exports